import {Alert, Button, Col, Container, Icon, Input, Row, Select} from "design-react-kit";
import React, { useEffect, useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import { properties } from "../../../config/properties";
import Spinner from "../../layout/Spinner";
import CustomTooltip from "../../utils/customToolTip";

const styles = {

    sidebar: {
        backgroundColor: "#0b5ed7", // blu
        padding: "1rem",
        borderRadius: "8px",
        minWidth: "180px",
        color: "white",
        fontWeight: "600",
    },
    sidebarButton: {
        backgroundColor:"white",
        margin: "0.5rem 0",
        width: "100%",
    },
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        //boxShadow: '0 6px 18px rgba(0, 0, 0, 0.06)',
        //border: 'none',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        transition: 'transform 0.2s ease-in-out',
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
};

const ModificaPersona = ({user}) => {
    const location = useLocation();
    const { idProfilo } = location.state || {};
    const [profilo, setProfilo] = useState(null);

    const [titoli, setTitoli] = useState([]);
    const [ruoli, setRuoli] = useState([]);
    const [aree, setAree] = useState([]);
    const [titolo, setTitolo] = useState('null');
    const [ruolo, setRuolo] = useState('');
    const [area, setArea] = useState('');
    const [nome, setNome] = useState( '');
    const [cognome, setCognome] = useState('');
    const [codiceFiscale, setCodiceFiscale] = useState('');

    const navigate = useNavigate();

    const [loadingUser, setLoadingUser] = useState(true);

    const [tooltipField, setTooltipField] = useState(null);
    const [tooltipMessage, setTooltipMessage] = useState('');

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });


    /*
    useEffect(() => {
        if (idProfilo) {
            getRuoliList();
            getAreeList();
            getTitoliList();
            getDettagliProfilo({ id: idProfilo.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente });
        }
    }, [idProfilo]);


     */

    useEffect(() => {
        if (idProfilo) {
            // Sequenza di chiamate
            getRuoliList()
                .then(() => getAreeList())
                .then(() => getTitoliList())
                .then(() =>
                    getDettagliProfilo({
                        id: idProfilo.id,
                        userID: user.userID,
                        cciaa: user.cciaa,
                        gruppoUtente: user.gruppoUtente
                    })
                )
                .catch((err) => {
                    console.error("Errore in una delle chiamate:", err);
                });
        }
    }, [idProfilo]);


    async function getRuoliList() {
        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/ruoli`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const data = await res.json();
            setRuoli(data?.ruoli ?? []);

        } catch (e) {
            return [];
        }
    }

    async function getAreeList() {
        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/areeCompetenza`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }
            if (!res.ok) throw new Error("Errore HTTP");
            const data = await res.json();
            setAree(data?.areeCompetenza ?? []);

        } catch (e) {
            return [];
        }
    }

    async function getTitoliList() {
        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/titoli`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }
            if (!res.ok) throw new Error("Errore HTTP");
            const data = await res.json();
            setTitoli(data?.titoli ?? []);

        } catch (e) {
            return [];
        }
    }

    const getDettagliProfilo = async (params) => {


        try {

            setAlert({ visible: false, type: '', message: '' });

            setLoadingUser(true);

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/dettagliProfiloAdmin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(params),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setProfilo(null);

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!res.ok) throw new Error(`Errore HTTP: ${res.status}`);
            const data = await res.json();
            if (data && Object.keys(data).length > 0) {
                setProfilo(data);
                setTitolo(data.fkIdTitolo);
                setNome(data.nome);
                setCognome(data.cognome);
                setCodiceFiscale(data.codFiscale);
                setRuolo(data.fkIdRuolo);
                setArea(data.fkIdAreaCompetenza);

            } else {

                throw new Error("Profilo vuoto o non valido.");
            }

        } catch (e) {
            setProfilo(null);
        }finally {
            setLoadingUser(false);
        }
    };

    const handleConferma = async (e) => {

        e.preventDefault();

        if (!controllaCodiceFiscale(codiceFiscale)) {
            setTooltipField('codiceFiscale');
            setTooltipMessage('Codice fiscale non valido.');
            return; // Interrompe il submit
        }

        const dataPersona = {

            id: profilo.id,
            titolo,
            nome,
            cognome,
            codiceFiscale,
            ruolo,
            area,
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente
        }

        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/update/persona`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ dataPersona }),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const json = await res.json();

            const datiRicerca = {

                dati : {
                    "id" : profilo.id
                }
            };

            if(json.esito === 'OK'){

                navigate('/private/profiloPersona', { state: {esito: json, ricerca: datiRicerca ,  nomeProfilo : nome , cognomeProfilo : cognome} });

            }else{
                navigate('/private/profiloPersona', { state: { esito: json , ricerca: datiRicerca ,  nomeProfilo : nome , cognomeProfilo : cognome} });
            }


        } catch (e) {

            const json = {

                esito : "KO",
                messaggio: "Errore del server."
            }

            navigate('/private/profiloPersona', { state: { esito: json, ricerca: datiRicerca ,  nomeProfilo : nome , cognomeProfilo : cognome} });

        }
    };

    async function goToGestioneDeleghe(){


        navigate('/private/gestioneDeleghePersona', { state: { idProfilo : profilo.id , nomeProfilo : nome , cognomeProfilo : cognome} });

    }

    async function goToGestioneFirma(){

        if(profilo.firma){
            navigate('/private/gestioneFirma', { state: { idProfilo : profilo.id , nomeProfilo : profilo.nome , cognomeProfilo : profilo.cognome ,
                    firmaProfilo : profilo.firma.firma, firmaSiglaProfilo : profilo.firma.siglaFirma , firmaData : profilo.firma.dataFirma , statoFirma : profilo.firma.stato} });

        }else{
            navigate('/private/gestioneFirma', { state: { idProfilo : profilo.id , nomeProfilo : profilo.nome , cognomeProfilo : profilo.cognome} });
        }


    }

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento
        return (
            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">
                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <Spinner active/>
            </Container>
        );
    }

    function controllaCodiceFiscale(cfiscale) {
        if (!cfiscale || cfiscale.trim() === "") {
            return true;
        }

        const valore = cfiscale.trim().toUpperCase();
        const regex = /^[A-Z]{6}[0-9LMNP-V]{2}[A-EHLMPRST][0-9LMNP-V]{2}[A-Z][0-9LMNP-V]{3}[A-Z]$/;
        if (!regex.test(valore)) {
            return false;
        }

        const pos = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const pari = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5,
            6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24, 25
        ];
        const disp = [
            1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13,
            15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14,
            16, 10, 22, 25, 24, 23
        ];

        let cont = 0;
        for (let i = 0; i < 15; i++) {
            const j = pos.indexOf(valore.charAt(i));
            cont += (i % 2 === 0) ? disp[j] : pari[j];
        }

        const checkChar = String.fromCharCode((cont % 26) + 65);
        return valore.charAt(15) === checkChar;
    }

    const handleCodiceFiscaleValidation = (value) => {
        setCodiceFiscale(value);

        if (!controllaCodiceFiscale(value)) {
            setTooltipField('codiceFiscale');
            setTooltipMessage('Codice fiscale non valido.');
        } else {
            setTooltipField(null);
            setTooltipMessage('');
        }
    };


    const handleValidationInput = ({ field, value, setField, regex, errorMessage }) => {
        const valid = regex.test(value);
        if (valid) {
            setField(value);
            setTooltipField(null);
        } else {
            setTooltipField(field);
            setTooltipMessage(errorMessage);
        }
    };


    return (
        <div className="bg-white py-lg-5">
            <Container>

                <Row className="py-5">
                    <Col md={3}>
                        <div style={{...styles.card, zIndex:1, backgroundColor: "#f8f9fa"}} className={"sticky-md-top"}>
                            {/* <Button color="white" size="sm" style={styles.sidebarButton} onClick={() => {window.history.back();}}>
                                Indietro
                            </Button> */}

                            <Button size="sm" style={styles.sidebarButton} className={"btn btn-outline-primary"} onClick={() => goToGestioneFirma()}>
                                Gestione Firma
                            </Button>
                            <Button size="sm" style={styles.sidebarButton} className={"btn btn-outline-primary"} onClick={() => goToGestioneDeleghe()}>
                                Gestione Deleghe
                            </Button>
                        </div>
                    </Col>
                    <Col md={9}>
                        <div style={styles.card}>
                            <h2 style={styles.formTitle}>Modifica Persona</h2>

                            {alert.visible && (
                                <Alert color={alert.type} isOpen={alert.visible}
                                       toggle={() => setAlert({...alert, visible: false})}>
                                    {alert.message}
                                </Alert>
                            )}

                            <form onSubmit={handleConferma}>

                                <Row className="mb-4">
                                    <h2 style={styles.sectionTitle}>
                                        <Icon icon="it-user" size="sm" style={styles.titleIcon}/>
                                        Dati Anagrafici
                                    </h2>
                                </Row>

                                <Row className="mb-5">

                                    <Col>
                                        <Select
                                            id="titolo"
                                            label="Titolo"
                                            value={titolo}
                                            onChange={(e) => setTitolo(e)}
                                        >
                                            <option value="null">Seleziona un titolo</option>
                                            {titoli.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.descrizione}
                                                </option>
                                            ))}
                                        </Select>
                                    </Col>
                                </Row>

                                <Row>

                                    <Input
                                        id="nome"
                                        label="Nome *"
                                        type="text"
                                        wrapperClassName="col"
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        value={nome}
                                        onChange={(e) => handleValidationInput({
                                            field: "nome",
                                            value: e.target.value,
                                            setField: setNome,
                                            regex: /^[a-zA-Z\s]*$/,
                                            errorMessage: "Sono ammessi solo caratteri alfabetici."
                                        })}
                                        required
                                        maxLength={20}
                                    />
                                </Row>

                                <Row>
                                    <Input
                                        id="cognome"
                                        type="text"
                                        label={"Cognome *"}
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        wrapperClassName="col"
                                        value={cognome}
                                        onChange={(e) => handleValidationInput({
                                            field: "cognome",
                                            value: e.target.value,
                                            setField: setCognome,
                                            regex: /^[a-zA-Z\s]*$/,
                                            errorMessage: "Sono ammessi solo caratteri alfabetici."
                                        })}
                                        required
                                        maxLength={20}
                                    />
                                </Row>

                                <Row>
                                <Input
                                        id="codiceFiscale"
                                        label="Codice Fiscale"
                                        type="text"
                                        style={{color:'#1a1a1a', fontWeight:'700'}}
                                        wrapperClassName="col"
                                        value={codiceFiscale}
                                        onChange={(e) => handleCodiceFiscaleValidation(e.target.value)}
                                    />
                                </Row>

                                <Row className="mb-3">
                                    <h2 style={styles.sectionTitle}>
                                        <Icon icon="it-card" size="sm" style={styles.titleIcon}/>
                                        Posizione
                                    </h2>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Select
                                            id="ruolo"
                                            label="Ruolo *"
                                            value={ruolo}
                                            onChange={(e) => setRuolo(e)}
                                            required
                                        >
                                            <option value="">Seleziona un ruolo</option>
                                            {ruoli.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.titolo}
                                                </option>
                                            ))}
                                        </Select>
                                    </Col>
                                </Row>

                                <Row className="mb-5">
                                    <Col>
                                        <Select
                                            id="area"
                                            label="Area di competenza *"
                                            value={area}
                                            onChange={(e) => setArea(e)}
                                            required
                                        >
                                            <option value="">Seleziona un'area</option>
                                            {aree.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.descrAreaCompetenza}
                                                </option>
                                            ))}
                                        </Select>
                                    </Col>
                                </Row>

                                <Row className="d-flex justify-content-end">
                                    <Col sm="auto">
                                        <Button className={"btn btn-outline-primary"} type="submit">
                                            Conferma
                                        </Button>
                                    </Col>
                                </Row>
                            </form>
                        </div>
                    </Col>
                </Row>

            </Container>

            <CustomTooltip
                targetId={tooltipField}
                message={tooltipMessage}
                isOpen={tooltipField !== null}
                toggle={() => setTooltipField(null)}
            />
        </div>
    );
};

export default ModificaPersona;
